import { configure, getConsoleSink } from '@logtape/logtape';
import { lowestLoggingLevel } from './config';

// Category convention (platform / suite / app) is documented in CLAUDE.md; the root logger covers every category.
await configure({
	// Vite keeps logtape's module state across SSR restarts / HMR, so re-configuring would throw "Already configured".
	reset: import.meta.env.DEV,
	sinks: { console: getConsoleSink() },
	// The console sink lives only on the root logger; child categories inherit it.
	loggers: [
		{ category: ['logtape'], lowestLevel: 'error', sinks: ['console'], parentSinks: 'override' },
		{ category: [], lowestLevel: lowestLoggingLevel, sinks: ['console'] }
	]
});
